import axios from '../http'
import {
  INCIDENT_REASONS,
  SCHEDULING_PERIODS_ACTIVE,
  FILTER_STORES,
  ORDER_EDF_PARTNER_STATES,
  LIST_PODS,
  INACTIVE_PODS
} from '../endpoints'

const getIncidentReassons = (params = 'INCIDENCE') => axios.get(`${INCIDENT_REASONS}/${params}`)
const getRescheduleReassons = (params = 'RESCHEDULE') => axios.get(`${INCIDENT_REASONS}/${params}`)
const getSchedulesFilters = () => axios.get(SCHEDULING_PERIODS_ACTIVE)
const getStores = () => axios.get(FILTER_STORES)
const getStates = () => axios.get(ORDER_EDF_PARTNER_STATES)
const getListPods = id => axios.get(`${LIST_PODS}/${id}`)

const deletePodFile = id => axios.put(`${INACTIVE_PODS}/${id}`)

export default {
  getIncidentReassons,
  getRescheduleReassons,
  getSchedulesFilters,
  getStores,
  getStates,
  getListPods,
  deletePodFile
}



// WEBPACK FOOTER //
// ./src/repository/api/filters.js